<div class="card card-body mb-0">
    <h5 class="mb-3 border-bottom">{{"DASHBOARD.Brzi unos zadatka" | translate}}</h5>
    <form #formElement [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="common-form row g-3">

            <div class="col-sm-12 col-12 col-lg-6 col-xl-6 form-group">
                <label class="fw-bold">
                    {{ "PROPERTIES.Komitent" | translate }}
                    <app-tooltip key="invoice.komitent"></app-tooltip>
                </label>
                <div class="input-group">
                    <ng-select class="col p-0 form-select" [items]="komitenti" formControlName="komitent"
                        loadingText="Ucitavanje..." bindLabel="komitent" bindValue="sifra" [virtualScroll]="true"
                        [selectOnTab]="true" [searchFn]="customSearchFn" [clearable]="false"
                        (search)="setClientSearchText($event)">
                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div> {{ item.komitent }}</div>
                            <div class="text-muted small">
                                {{ item.addressString }}
                            </div>
                            <!--<div class="text-muted small">JIB: {{item.identifikacioniBroj}}</div>-->
                        </ng-template>
                    </ng-select>
                    <button (click)="openAddNewClientModal()" type="button" class="btn btn-primary">
                        <i class="fa fa-plus"></i>
                    </button>
                </div>
                <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
            validation: 'required',
            message: 'VALIDATORS.KomitentJeObavezan',
            control: this.form.controls.komitent
          }">
                </ng-container>
            </div>

            <div class="col-sm-12 col-12 col-lg-6 col-xl-6 form-group">
                <label class="fw-bold">
                    {{ "PROPERTIES.Za korisnika" | translate }}
                </label>
                <div class="input-group">
                    <ng-select class="col p-0 form-select" [items]="users" formControlName="zaOperatera"
                        loadingText="Ucitavanje..." bindLabel="search_label" bindValue="id" [virtualScroll]="true"
                        [selectOnTab]="true" [searchFn]="customSearchFn" [clearable]="false">
                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div> {{ item.firstName }} {{ item.lastName }}</div>
                        </ng-template>
                    </ng-select>
                </div>
                <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
            validation: 'required',
            message: 'VALIDATORS.PoljeNeSmijeBitiPrazno',
            control: this.form.controls.zaOperatera
          }">
                </ng-container>
            </div>

            <div class="col-12 form-group">
                <label class="fw-bold">
                    <span class=""> {{ "PROPERTIES.Zadatak" | translate }}</span>
                </label>
                <input formControlName="opis" class="form-control" type="text" />
                <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
            validation: 'required',
            message: 'VALIDATORS.PoljeNeSmijeBitiPrazno',
            control: this.form.controls.opis
          }">
                </ng-container>
            </div>

            <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 form-group">
                <label class="fw-bold">
                    <span class=""> {{"PROPERTIES.Od datuma" | translate}}</span>
                </label>
                <input class="form-control" type="datetime-local" formControlName="od_datuma"
                    (ngModelChange)="odDatumaChange($event)" />
            </div>

            <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 form-group">
                <label class="fw-bold">
                    <span class=""> {{"PROPERTIES.Do datuma" | translate}}</span>
                </label>
                <input class="form-control" type="datetime-local" formControlName="do_datuma"
                    (ngModelChange)="doDatumaChange($event)" />
            </div>


        </div>

        <div class="col12 mt-4 text-end">
            <button class="btn btn-light me-3" type="button" (click)="closeModal()">
                {{ "PROPERTIES.Otkazi" | translate }}
            </button>
            <button class="btn btn-primary">
                {{ "PROPERTIES.SpremiIzmjene" | translate }}
            </button>
        </div>
    </form>
</div>

<ng-template #formError let-control="control" let-message="message" let-validation="validation">
    <ng-container *ngIf="control.hasError(validation) && control.touched">
        <small class="text-danger">{{ message | translate }}</small>
    </ng-container>
</ng-template>